import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import MenuSection from "../components/MenuSection";
import Gallery from "../components/Gallery";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { useContent } from "../contexts/ContentContext";

export default function Home() {
    const { loading, content } = useContent();

    if (loading || !content) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-brand-cream">
                <div className="font-display text-4xl text-brand-navy animate-pulse">Zarautz</div>
            </div>
        );
    }

    return (
        <div className="bg-brand-cream">
            <Header />
            <main>
                <Hero />
                <About />
                <MenuSection />
                <Gallery />
                <FAQ />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
